import { Effect, Layer } from "effect";
import { resourceUnavailable } from "@workerstation/shared/errors/resource";
import { RecordingScopeIo, RecordingRecentScopes, makeRecordingRecentScopes } from "./service.ts";
const STORAGE_KEY = "workerstation.recent-flow-scopes";
export const RecordingScopeIoLive = Layer.succeed(RecordingScopeIo, RecordingScopeIo.of({
    read: Effect.try({ try: () => globalThis.localStorage?.getItem(STORAGE_KEY) ?? null, catch: () => resourceUnavailable() }),
    write: value => Effect.try({ try: () => { globalThis.localStorage?.setItem(STORAGE_KEY, value); }, catch: () => resourceUnavailable() }),
    now: Effect.try({ try: () => Date.now(), catch: () => resourceUnavailable() })
}));
export const RecordingRecentScopesLive = Layer.effect(RecordingRecentScopes, makeRecordingRecentScopes).pipe(Layer.provide(RecordingScopeIoLive));
